import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Alert,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Divider,
  Tooltip,
  Badge,
  Avatar,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  FormControlLabel,
  Switch,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
  AlertTitle,
  Snackbar,
  Drawer,
  AppBar,
  Toolbar,
  Breadcrumbs,
  Link,
  Rating,
  ListItemButton,
  ListItemAvatar,
  ListItemSecondaryAction,
  CardMedia,
  CardActions,
} from '@mui/material';
import {
  CheckCircle,
  Error,
  Warning,
  Info,
  TrendingUp,
  TrendingDown,
  ExpandMore,
  Close,
  ArrowBack,
  ArrowForward,
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Notifications,
  Settings,
  Help,
  ContactSupport,
  History,
  Assessment,
  Analytics,
  Timeline,
  Receipt,
  Payment,
  AccountBalance,
  QrCode,
  Description,
  Schedule,
  LocalShipping,
  AttachMoney,
  AccountBalanceWallet,
  Security,
  Verified,
  Lock,
  Visibility,
  VisibilityOff,
  Print,
  Download,
  Share,
  Email,
  Phone,
  Business,
  Person,
  LocationOn,
  CalendarToday,
  AccessTime,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  ExpandMore as ExpandMoreIcon,
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  ContactSupport as ContactSupportIcon,
  History as HistoryIcon,
  Assessment as AssessmentIcon,
  Analytics as AnalyticsIcon,
  Timeline as TimelineIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  AccountBalance as AccountBalanceIcon,
  QrCode as QrCodeIcon,
  Description as DescriptionIcon,
  Schedule as ScheduleIcon,
  LocalShipping as LocalShippingIcon,
  AttachMoney as AttachMoneyIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Security as SecurityIcon,
  Verified as VerifiedIcon,
  Lock as LockIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Print as PrintIcon,
  Download as DownloadIcon,
  Share as ShareIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  LocationOn as LocationOnIcon,
  CalendarToday as CalendarTodayIcon,
  AccessTime as AccessTimeIcon,
  Add,
  Edit,
  Delete,
  Search,
  FilterList,
  Sort,
  Refresh,
  Build,
  Engineering,
  Speed,
  Timer,
  Work,
  Assignment,
  Inventory,
  ProductionQuantityLimits,
  Category,
  Palette,
  Straighten,
  Scale,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  Build as BuildIcon,
  Engineering as EngineeringIcon,
  Speed as SpeedIcon,
  Timer as TimerIcon,
  Work as WorkIcon,
  Assignment as AssignmentIcon,
  Inventory as InventoryIcon,
  ProductionQuantityLimits as ProductionQuantityLimitsIcon,
  Category as CategoryIcon,
  Palette as PaletteIcon,
  Straighten as StraightenIcon,
  Scale as ScaleIcon,
} from '@mui/icons-material';
import { useGetQualityChecksQuery, qualityControlApi } from '../../api/qualityControlApi';
import { format, parseISO, addDays, isAfter, isBefore, differenceInHours } from 'date-fns';
import { useRbac } from '../../context/RbacContext';

interface QualityCheck {
  id: string;
  orderItem: {
    id: string;
    type: string;
    quantity: number;
    productionLine: {
      id: string;
      name: string;
    };
  };
  status: 'pending' | 'passed' | 'failed' | 'rejected' | 'in_progress';
  createdAt: string;
  updatedAt?: string;
  inspector?: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  category: 'visual' | 'functional' | 'measurement' | 'safety';
  template: string;
  inspections: {
    id: string;
    inspector: string;
    results: any;
    createdAt: string;
    status: 'pass' | 'fail' | 'warning';
    notes?: string;
  }[];
  defects: Array<{
    id: string;
    type: string;
    severity: 'low' | 'medium' | 'high' | 'critical';
    description: string;
    location: string;
    reportedBy: string;
    reportedAt: string;
    status: 'open' | 'investigating' | 'resolved' | 'closed';
  }>;
  metrics: {
    passRate: number;
    defectRate: number;
    averageInspectionTime: number;
    totalInspections: number;
  };
}

interface QualityAnalytics {
  totalChecks: number;
  passedChecks: number;
  failedChecks: number;
  pendingChecks: number;
  passRate: number;
  averageInspectionTime: number;
  topDefects: Array<{
    type: string;
    count: number;
    percentage: number;
  }>;
  inspectorPerformance: Array<{
    name: string;
    checksCompleted: number;
    passRate: number;
    averageTime: number;
  }>;
  categoryBreakdown: Array<{
    category: string;
    count: number;
    passRate: number;
  }>;
  trends: Array<{
    date: string;
    checks: number;
    passRate: number;
  }>;
}

interface QualityTemplate {
  id: string;
  name: string;
  category: string;
  description: string;
  criteria: Array<{
    id: string;
    name: string;
    type: 'measurement' | 'visual' | 'functional' | 'safety';
    standard: string;
    minValue?: number;
    maxValue?: number;
    unit?: string;
    required: boolean;
  }>;
  status: 'active' | 'inactive' | 'draft';
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export const QualityControlManagement: React.FC = () => {
  const { hasPermission } = useRbac();
  const [tabIndex, setTabIndex] = useState(0);
  const [qualityChecks, setQualityChecks] = useState<QualityCheck[]>([]);
  const [templates, setTemplates] = useState<QualityTemplate[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCheck, setSelectedCheck] = useState<QualityCheck | null>(null);
  const [selectedTemplate, setSelectedTemplate] = useState<QualityTemplate | null>(null);
  const [newInspection, setNewInspection] = useState({
    inspector: '',
    results: {},
    notes: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState({
    status: 'all',
    priority: 'all',
    category: 'all',
    inspector: 'all'
  });
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');

  const { data: qualityChecksData, isLoading: isQualityChecksLoading, refetch: fetchQualityChecks } = useGetQualityChecksQuery();

  // Mock analytics
  const [analytics, setAnalytics] = useState<QualityAnalytics>({
    totalChecks: 0,
    passedChecks: 0,
    failedChecks: 0,
    pendingChecks: 0,
    passRate: 0,
    averageInspectionTime: 0,
    topDefects: [],
    inspectorPerformance: [],
    categoryBreakdown: [],
    trends: []
  });

  useEffect(() => {
    if (!isQualityChecksLoading) {
      setQualityChecks((qualityChecksData as QualityCheck[]) || []);
    }
  }, [qualityChecksData, isQualityChecksLoading]);

  useEffect(() => {
    // Calculate analytics
    const totalChecks = qualityChecks.length;
    const passedChecks = qualityChecks.filter(check => check.status === 'passed').length;
    const failedChecks = qualityChecks.filter(check => check.status === 'failed').length;
    const pendingChecks = qualityChecks.filter(check => check.status === 'pending').length;
    const passRate = totalChecks > 0 ? (passedChecks / totalChecks) * 100 : 0;

    // Calculate top defects
    const defectCounts: Record<string, number> = {};
    qualityChecks.forEach(check => {
      check.defects.forEach(defect => {
        defectCounts[defect.type] = (defectCounts[defect.type] || 0) + 1;
      });
    });

    const topDefects = Object.entries(defectCounts)
      .map(([type, count]) => ({
        type,
        count,
        percentage: (count / totalChecks) * 100
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);

    // Mock inspector performance
    const inspectorPerformance = [
      { name: 'John Doe', checksCompleted: 45, passRate: 92, averageTime: 15 },
      { name: 'Jane Smith', checksCompleted: 38, passRate: 89, averageTime: 18 },
      { name: 'Mike Johnson', checksCompleted: 52, passRate: 95, averageTime: 12 }
    ];

    // Mock category breakdown
    const categoryBreakdown = [
      { category: 'Visual', count: 120, passRate: 88 },
      { category: 'Functional', count: 85, passRate: 92 },
      { category: 'Measurement', count: 65, passRate: 95 },
      { category: 'Safety', count: 40, passRate: 100 }
    ];

    setAnalytics({
      totalChecks,
      passedChecks,
      failedChecks,
      pendingChecks,
      passRate,
      averageInspectionTime: 15, // Mock value
      topDefects,
      inspectorPerformance,
      categoryBreakdown,
      trends: [
        { date: '2024-01-20', checks: 25, passRate: 88 },
        { date: '2024-01-21', checks: 30, passRate: 90 },
        { date: '2024-01-22', checks: 28, passRate: 92 },
        { date: '2024-01-23', checks: 35, passRate: 89 },
        { date: '2024-01-24', checks: 32, passRate: 91 }
      ]
    });
  }, [qualityChecks]);

  // Mock templates
  useEffect(() => {
    setTemplates([
      {
        id: '1',
        name: 'Visual Inspection Template',
        category: 'visual',
        description: 'Standard visual inspection for all products',
        criteria: [
          {
            id: '1',
            name: 'Surface Finish',
            type: 'visual',
            standard: 'Smooth, no visible defects',
            required: true
          },
          {
            id: '2',
            name: 'Color Consistency',
            type: 'visual',
            standard: 'Uniform color throughout',
            required: true
          }
        ],
        status: 'active',
        createdBy: 'admin@company.com',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-15T00:00:00Z'
      },
      {
        id: '2',
        name: 'Functional Test Template',
        category: 'functional',
        description: 'Functional testing for electronic components',
        criteria: [
          {
            id: '3',
            name: 'Power Consumption',
            type: 'measurement',
            standard: 'Within specified range',
            minValue: 0.5,
            maxValue: 2.0,
            unit: 'W',
            required: true
          },
          {
            id: '4',
            name: 'Response Time',
            type: 'measurement',
            standard: 'Less than 100ms',
            maxValue: 100,
            unit: 'ms',
            required: true
          }
        ],
        status: 'active',
        createdBy: 'admin@company.com',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-15T00:00:00Z'
      }
    ]);
  }, []);

  const handleUpdateStatus = async (id: string, status: string) => {
    try {
      await qualityControlApi.endpoints.updateQualityCheck.initiate({ id, data: { status } });
      await fetchQualityChecks();
    } catch (err) {
      setError('Failed to update quality check status');
    }
  };

  const handleCreateInspection = async () => {
    try {
      setLoading(true);
      setError(null);

      await qualityControlApi.endpoints.createQualityCheck.initiate(newInspection as Record<string, unknown>);
      await fetchQualityChecks();
      setOpenDialog(false);
      setNewInspection({
        inspector: '',
        results: {},
        notes: ''
      });
    } catch (err) {
      setError('Failed to create inspection');
    } finally {
      setLoading(false);
    }
  };

  const handleExportReport = (format: 'pdf' | 'excel' | 'csv') => {
    // Mock export functionality
    console.log(`Exporting quality report in ${format} format`);
  };

  const renderStatusChip = (status: string) => {
    const color = {
      pending: 'warning',
      passed: 'success',
      failed: 'error',
      rejected: 'error',
      in_progress: 'info',
    }[status];

    return (
      <Chip
        label={status}
        color={color as 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'}
        size="small"
        sx={{ mr: 1 }}
      />
    );
  };

  const renderPriorityChip = (priority: string) => {
    const color = {
      low: 'success',
      medium: 'warning',
      high: 'error',
      critical: 'error'
    }[priority];

    return (
      <Chip
        label={priority.toUpperCase()}
        color={color as any}
        size="small"
      />
    );
  };

  const renderCategoryChip = (category: string) => {
    const color = {
      visual: 'primary',
      functional: 'secondary',
      measurement: 'info',
      safety: 'warning'
    }[category];

    return (
      <Chip
        label={category.toUpperCase()}
        color={color as any}
        size="small"
      />
    );
  };

  const filteredQualityChecks = qualityChecks.filter(check => {
    const matchesSearch = check.orderItem.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         check.orderItem.productionLine.name.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = filter.status === 'all' || check.status === filter.status;
    const matchesPriority = filter.priority === 'all' || check.priority === filter.priority;
    const matchesCategory = filter.category === 'all' || check.category === filter.category;
    
    return matchesSearch && matchesStatus && matchesPriority && matchesCategory;
  });

  const sortedQualityChecks = [...filteredQualityChecks].sort((a, b) => {
    let aValue = a[sortBy as keyof QualityCheck];
    let bValue = b[sortBy as keyof QualityCheck];
    
    if (typeof aValue === 'string') aValue = aValue.toLowerCase();
    if (typeof bValue === 'string') bValue = bValue.toLowerCase();
    
    if ((aValue as any) < (bValue as any)) return sortOrder === 'asc' ? -1 : 1;
    if ((aValue as any) > (bValue as any)) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircleIcon color="primary" />
        Quality Control Management
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* Analytics Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Total Checks
              </Typography>
              <Typography variant="h4">
                {analytics.totalChecks}
              </Typography>
              <LinearProgress variant="determinate" value={100} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Pass Rate
              </Typography>
              <Typography variant="h4" color="success.main">
                {analytics.passRate.toFixed(1)}%
              </Typography>
              <LinearProgress 
                variant="determinate" 
                value={analytics.passRate} 
                sx={{ mt: 1 }} 
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Failed Checks
              </Typography>
              <Typography variant="h4" color="error.main">
                {analytics.failedChecks}
              </Typography>
              <LinearProgress variant="determinate" value={analytics.failedChecks > 0 ? 100 : 0} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Avg Inspection Time
              </Typography>
              <Typography variant="h4" color="info.main">
                {analytics.averageInspectionTime} min
              </Typography>
              <LinearProgress variant="determinate" value={75} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Quality Checks" />
          <Tab label="Templates" />
          <Tab label="Analytics" />
          <Tab label="Reports" />
        </Tabs>
      </Paper>

      {tabIndex === 0 && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Quality Checks</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                placeholder="Search checks..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filter.status}
                  onChange={(e) => setFilter(prev => ({ ...prev, status: e.target.value }))}
                  label="Status"
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="in_progress">In Progress</MenuItem>
                  <MenuItem value="passed">Passed</MenuItem>
                  <MenuItem value="failed">Failed</MenuItem>
                  <MenuItem value="rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Priority</InputLabel>
                <Select
                  value={filter.priority}
                  onChange={(e) => setFilter(prev => ({ ...prev, priority: e.target.value }))}
                  label="Priority"
                >
                  <MenuItem value="all">All Priorities</MenuItem>
                  <MenuItem value="low">Low</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="high">High</MenuItem>
                  <MenuItem value="critical">Critical</MenuItem>
                </Select>
              </FormControl>
              <IconButton onClick={() => fetchQualityChecks()}>
                <Refresh />
              </IconButton>
            </Box>
          </Box>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Order Item</TableCell>
                  <TableCell>Production Line</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Priority</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Inspector</TableCell>
                  <TableCell>Created</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedQualityChecks.map((check) => (
                  <TableRow key={check.id} hover>
                    <TableCell>
                      <Box>
                        <Typography variant="subtitle2">{check.orderItem.type}</Typography>
                        <Typography variant="caption" color="textSecondary">
                          Qty: {check.orderItem.quantity}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{check.orderItem.productionLine.name}</TableCell>
                    <TableCell>{renderStatusChip(check.status)}</TableCell>
                    <TableCell>{renderPriorityChip(check.priority)}</TableCell>
                    <TableCell>{renderCategoryChip(check.category)}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ width: 24, height: 24 }}>
                          <Person />
                        </Avatar>
                        {check.inspector || 'Unassigned'}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {format(parseISO(check.createdAt), 'MMM dd, yyyy')}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="View Details">
                          <IconButton
                            size="small"
                            onClick={() => setSelectedCheck(check)}
                          >
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                        {check.status === 'pending' && (
                          <Tooltip title="Start Inspection">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedCheck(check);
                                setOpenDialog(true);
                              }}
                              disabled={!hasPermission('quality:inspect')}
                              color="success"
                            >
                              <CheckCircle />
                            </IconButton>
                          </Tooltip>
                        )}
                        {check.status === 'in_progress' && (
                          <Tooltip title="Complete Inspection">
                            <IconButton
                              size="small"
                              onClick={() => handleUpdateStatus(check.id, 'passed')}
                              disabled={!hasPermission('quality:inspect')}
                              color="success"
                            >
                              <CheckCircle />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {tabIndex === 1 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Quality Templates
          </Typography>
          <Grid container spacing={2}>
            {templates.map((template) => (
              <Grid item xs={12} md={6} lg={4} key={template.id}>
                <Card>
                  <CardHeader
                    title={template.name}
                    subheader={template.category}
                    action={
                      <Chip
                        label={template.status}
                        color={template.status === 'active' ? 'success' : 'default'}
                        size="small"
                      />
                    }
                  />
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      {template.description}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {template.criteria.length} criteria
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="caption" color="textSecondary">
                        Created: {format(parseISO(template.createdAt), 'MMM dd, yyyy')}
                      </Typography>
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Button size="small" startIcon={<Visibility />}>
                      View
                    </Button>
                    <Button size="small" startIcon={<Edit />}>
                      Edit
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {tabIndex === 2 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Quality Analytics
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Top Defects" />
                <CardContent>
                  <List>
                    {analytics.topDefects.map((defect, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={defect.type}
                          secondary={`${defect.count} occurrences`}
                        />
                        <ListItemSecondaryAction>
                          <Typography variant="body2" color="error.main">
                            {defect.percentage.toFixed(1)}%
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Inspector Performance" />
                <CardContent>
                  <List>
                    {analytics.inspectorPerformance.map((inspector, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={inspector.name}
                          secondary={`${inspector.checksCompleted} checks`}
                        />
                        <ListItemSecondaryAction>
                          <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="body2" color="success.main">
                              {inspector.passRate}%
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {inspector.averageTime} min avg
                            </Typography>
                          </Box>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardHeader title="Category Breakdown" />
                <CardContent>
                  <Grid container spacing={2}>
                    {analytics.categoryBreakdown.map((category, index) => (
                      <Grid item xs={12} sm={6} md={3} key={index}>
                        <Box sx={{ textAlign: 'center' }}>
                          <Typography variant="h6" color="primary.main">
                            {category.count}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {category.category}
                          </Typography>
                          <Typography variant="caption" color="success.main">
                            {category.passRate}% pass rate
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {tabIndex === 3 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Quality Reports
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Export Reports" />
                <CardContent>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Button
                      variant="outlined"
                      startIcon={<Download />}
                      onClick={() => handleExportReport('pdf')}
                    >
                      Export PDF
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<Download />}
                      onClick={() => handleExportReport('excel')}
                    >
                      Export Excel
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<Download />}
                      onClick={() => handleExportReport('csv')}
                    >
                      Export CSV
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Report Templates" />
                <CardContent>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="Daily Quality Report"
                        secondary="Summary of daily quality checks and results"
                      />
                      <Button size="small">Generate</Button>
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary="Weekly Analytics Report"
                        secondary="Weekly trends and performance metrics"
                      />
                      <Button size="small">Generate</Button>
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary="Defect Analysis Report"
                        secondary="Detailed analysis of defects and root causes"
                      />
                      <Button size="small">Generate</Button>
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {/* Inspection Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          Quality Inspection - {selectedCheck?.orderItem.type}
        </DialogTitle>
        <DialogContent>
          {selectedCheck && (
            <Box>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Order Item</Typography>
                  <Typography variant="h6">{selectedCheck.orderItem.type}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Production Line</Typography>
                  <Typography variant="h6">{selectedCheck.orderItem.productionLine.name}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }} />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Inspector Name"
                    value={newInspection.inspector}
                    onChange={(e) => setNewInspection(prev => ({ ...prev, inspector: e.target.value }))}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Inspection Notes"
                    multiline
                    rows={4}
                    value={newInspection.notes}
                    onChange={(e) => setNewInspection(prev => ({ ...prev, notes: e.target.value }))}
                    margin="normal"
                    placeholder="Enter detailed inspection notes..."
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button
            onClick={handleCreateInspection}
            variant="contained"
            disabled={loading || !hasPermission('quality:inspect')}
          >
            {loading ? <CircularProgress size={20} /> : 'Submit Inspection'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
